import React, { useEffect, useRef, useState } from 'react'
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import axios from 'axios';
import { baseUrl, path } from '../../constants';
import Player from '../../HulluWare/Player';
import { Oval } from 'react-loader-spinner';
import CancelIcon from '@mui/icons-material/Cancel';
import {api} from "../../api"

export default function Preview({ courseId, setSelectedCourse, selectedCourse }) {
    console.log(selectedCourse)
    let s = selectedCourse
    const [loaded, setLoaded] = useState(true)
    const [progress, setProgress] = useState(0)
    const fileRef = useRef()
    const [source, setSource] = useState({
            url: baseUrl + s.preview,
            label: s.type,
            type: 'application/x-mpegURL',
            previewThumbnail: s.previewThumbnail,
            thumbnail: s.thumbnail,
            values: s.languages
    })
    // const config = {
    //     onUploadProgress: progressEvent => console.log(progressEvent.loaded)
    // }

    useEffect(() => {
        // api(path.getVideoStream + '/' + courseId + '?preview=true').then(response => {
        //     const data = response.data
        //     if(data.success){
        //         if(data.stream?.path){
        //             let s = data.stream
        //             setSource({
        //                 url: baseUrl + s.path,
        //                 label: s.type,
        //                 type: 'application/x-mpegURL',
        //                 previewThumbnail: s.previewThumbnail,
        //                 thumbnail: s.thumbnail
        //             })
        //             setLoaded(true)
        //         } else {
        //             setLoaded(false)
        //         }
        //     }
        // })
    }, [])
    
    
  return (
    <div className='fixed inset-0 bg-[#00000070] flex items-center justify-center'>
        <div className='flex items-center justify-center flex-col bg-white w-[70%] h-[80%] relative rounded-md gap-5'>
            {!s.preview &&
            [<div className='flex flex-col gap-2 items-center'>
                {/* <input onChange={event => uploadStream(event.target.files[0])} type='file' ref={fileRef} hidden /> */}
                <VideocamOffIcon style={{fontSize: 60, color: '#000000'}}>Filled</VideocamOffIcon>
                <p className='text-black font-bold text-[25px]'>No preview is found for this course.</p>
            </div>,
            // <button disabled={progress != 0} onClick={() => fileRef.current.click()} className='outline-none border-none bg-main px-5 py-2 text-[22px] rounded-sm text-white'>
            // {progress == 0 ? 'Upload Video' : progress == 100 ? 'Transcoding...' :  `Uploading Video ${progress.toFixed(2)}%`}
            // </button>
            
            ] }
            {/* {loaded == null && (
                    <div className='flex flex-col gap-3 flex-1 items-center justify-center'>
                        <p className='text-[16px]'>Loading section...</p>
                        <Oval
                            visible={true}
                            height="30"
                            width="30"
                            color="#198754"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                        />
                    </div>
            )} */}
             {s.preview && <Player options={{source}} style={{}} /> }
             {/* {progress == true && <p className='text-main bg-[#c0faba] px-8 py-2 text-[17px] font-bold'>Video successfully transcoded.</p>} */}
             <button onClick={() => setSelectedCourse(null)} className='absolute outline-none bg-white rounded-full bg-none -top-4 -right-4'>
                <CancelIcon style={{fontSize: 25, color: '#000000'}}>Filled</CancelIcon>
             </button>
        </div>
    </div>
  )
}
